import { ChangeDetectionStrategy, Component, ContentChildren } from '@angular/core';

import { ItemComponent } from '../item/item.component';

// TODO to be removed, empty component without styles
@Component({
  selector: 'rt-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ListComponent {
  @ContentChildren(ItemComponent) public itemComponents: ItemComponent[];
}
